<google-map class="google-map"
            height="90vh"
            width="100%"
            [options]="mapOptions">
  <map-marker *ngFor="let marker of markers" #somemarker="mapMarker"
              [position]="marker.position"
              [label]="marker.label"
              [title]="marker.title"
              [icon]="marker.icon"
              (mapClick)="displayLocationPopup(somemarker, marker)"
              [options]="marker.options"></map-marker>
  <map-info-window>
    <div>
      <strong>Förare:</strong> {{infoContent?.driver}}<br /><br />
      <strong>Uppdrag:</strong> {{infoContent?.assignment}}<br /><br />
      <strong>Tid:</strong> {{infoContent?.start}} - {{infoContent?.end}}<br /><br />
    </div> 
  </map-info-window>
</google-map>

